import { HttpClient } from "_fil_local_addon/camc-cms-base/index";
import { FUND_API_SOURCES } from "_fil_local_addon/camc-cms-base/amc_fund_api.constant";
import { UrlTool } from "_fil_local_addon/camc-cms-base/index";
import FundReportService from "_fil_local_addon/camc-fund-report-list/fund_report_service";

class CAMCFundAsset {
    constructor(fundCode) {
        this.fundCode = fundCode;
        this.reportTime = null;
        this.httpClient = new HttpClient();
        this.pieChart;
        this.fund_portfolio_asset_api = FUND_API_SOURCES.FUND_PORTFOLIO_ASSET_SOURCE;
    }

    async render() {
        try {
            this.reportTime = await FundReportService.getReportTime(this.fundCode);
            if (!this.reportTime) {
                this.setEmptyMessage();
            } else {
                const assetData = await this.getAssetData();
                this.renderAssetData(assetData);
            }
        } catch (error) {
            this.setEmptyMessage();
        }
    }

    async getAssetData() {
        const assetUrl = UrlTool.addPath(this.fund_portfolio_asset_api, this.fundCode);
        let options = {
            errorHandler: () => {
                this.errorHandler();
            },
            data: {
                asat: this.reportTime,
            },
        };
        const assetData = await this.httpClient.get(assetUrl, options);
        return assetData;
    }

    renderAssetData(fundAssetData) {
        let updateDate;
        let assetData;
        let assetDataArray = [];
        let assetResData = fundAssetData.data;
        if (assetResData !== null && assetResData.assetBreakdown) {
            for (let i = 0; i < assetResData.assetBreakdown.length; i++) {
                let element = assetResData.assetBreakdown[i];
                assetData = [element.assetAllName, element.fundWT];
                assetDataArray.push(assetData);
            }
            updateDate = assetResData.asat;
            if (updateDate) {
                this.updateFundDate(updateDate);
            }
            this.createPieChart(assetDataArray);
        } else {
            this.errorHandler();
        }
    }

    setEmptyMessage(containerId) {}

    errorHandler() {}

    updateFundDate(date) {}

    createPieChart(assetDataArray) {}
}

export default CAMCFundAsset;
